export default function BotaoBroadCast(props) {
    return (
        <button onClick={props.clicado} className="bg-blue-600 w-full py-1 border-none rounded-md hover:bg-blue-500 text-gray-200 " >{props.texto}</button>
    )
}